"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TESTIMONIAL_MODULE_NAME = exports.TESTIMONIAL_CAROUSEL_TITLE = exports.TESTIMONIAL_CAROUSEL_STARS = exports.TESTIMONIAL_CAROUSEL_SLIDE = exports.TESTIMONIAL_CAROUSEL_INTERVAL = exports.TESTIMONIAL_CAROUSEL_IMAGE = exports.TESTIMONIAL_CAROUSEL_ID = exports.TESTIMONIAL_CAROUSEL_DESCRIPTION = exports.TESTIMONIAL_CAROUSEL_AUTHOR = void 0;
const TESTIMONIAL_MODULE_NAME = exports.TESTIMONIAL_MODULE_NAME = 'EditorialTestimonialCarousel';
const TESTIMONIAL_CAROUSEL_ID = exports.TESTIMONIAL_CAROUSEL_ID = 'testimonial-carousel-id';
const TESTIMONIAL_CAROUSEL_SLIDE = exports.TESTIMONIAL_CAROUSEL_SLIDE = 'testimonial-carousel-slide';
const TESTIMONIAL_CAROUSEL_STARS = exports.TESTIMONIAL_CAROUSEL_STARS = 'testimonial-carousel-stars';
const TESTIMONIAL_CAROUSEL_TITLE = exports.TESTIMONIAL_CAROUSEL_TITLE = 'testimonial-carousel-title';
const TESTIMONIAL_CAROUSEL_IMAGE = exports.TESTIMONIAL_CAROUSEL_IMAGE = 'testimonial-carousel-image';
const TESTIMONIAL_CAROUSEL_DESCRIPTION = exports.TESTIMONIAL_CAROUSEL_DESCRIPTION = 'testimonial-carousel-description';
const TESTIMONIAL_CAROUSEL_AUTHOR = exports.TESTIMONIAL_CAROUSEL_AUTHOR = 'testimonial-carousel-author';
const TESTIMONIAL_CAROUSEL_INTERVAL = exports.TESTIMONIAL_CAROUSEL_INTERVAL = 5000;
